// do nothing
export const NOTHING = 'NOTHING'

// Signup
export const CHANGE_SIGNUP_STEP = 'CHANGE_SIGNUP_STEP'
export const UPDATE_SIGNUP_DATA = 'UPDATE_SIGNUP_DATA'
export const FETCH_SIGNUP_DATA_REQUEST = 'FETCH_SIGNUP_DATA_REQUEST'
export const FETCH_SIGNUP_ADDRESSES_REQUEST = 'FETCH_SIGNUP_ADDRESSES_REQUEST'
export const SIGNUP_REQUEST = 'SIGNUP_REQUEST'
export const SIGNUP_SAVE_PASSWORD_REQUEST = 'SIGNUP_SAVE_PASSWORD_REQUEST'
export const SEND_SMS_REQUEST = 'SEND_SMS_REQUEST'
export const RECEIVE_SMS_AUTH_CODE_REQUEST = 'RECEIVE_SMS_AUTH_CODE_REQUEST'
export const FETCH_REQUEST_INFO_REQUEST = 'FETCH_REQUEST_INFO_REQUEST'
export const UPDATE_REQUEST_INFO_REQUEST = 'UPDATE_REQUEST_INFO_REQUEST'
export const FETCH_CUSTOMER_INFO_REQUEST = 'FETCH_CUSTOMER_INFO_REQUEST'
export const UPDATE_CUSTOMER_INFO_REQUEST = 'UPDATE_CUSTOMER_INFO_REQUEST'
export const UPLOAD_FILE_REQUEST = 'UPLOAD_FILE_REQUEST'
export const UPLOAD_DIRECTORY_REQUEST = 'UPLOAD_DIRECTORY_REQUEST'
export const UPDATE_DIRECTORY_UPLOAD_PROGRESS = 'UPDATE_DIRECTORY_UPLOAD_PROGRESS'
export const UPLOAD_FILE_S3_REQUEST = 'UPLOAD_FILE_S3_REQUEST'
export const SEARCH_HOSPITAL_REQUEST = 'SEARCH_HOSPITAL_REQUEST'
export const FETCH_CONSULTATION_OPTIONS_REQUEST = 'FETCH_CONSULTATION_OPTIONS_REQUEST'
export const DELETE_FILE_REQUEST = 'DELETE_FILE_REQUEST'
export const DELETE_DIRECTORY_UPLOAD_REQUEST = 'DELETE_DIRECTORY_UPLOAD_REQUEST'
export const FETCH_PAYJP_INFO_REQUEST = 'FETCH_PAYJP_INFO_REQUEST'
export const FETCH_ANNOTATION_PRICE_REQUEST = 'FETCH_ANNOTATION_PRICE_REQUEST'
export const FETCH_DATA_FILE_REQUEST = 'FETCH_DATA_FILE_REQUEST'
export const UPDATE_QUESTIONS = 'UPDATE_QUESTIONS'
export const UPDATE_FILE_TARGET_ID_REQUEST = 'UPDATE_FILE_TARGET_ID_REQUEST'

// Login
export const LOGIN_RESET_STATE = 'LOGIN_RESET_STATE'
export const LOGIN_UPDATE_STATE = 'LOGIN_UPDATE_STATE'

// Logout
export const LOGOUT = 'LOGOUT'

// Reset Password
export const RESET_PASSWORD_RESET_STATE = 'RESET_PASSWORD_RESET_STATE'
export const RESET_PASSWORD_UPDATE_STATE = 'RESET_PASSWORD_UPDATE_STATE'

//Chatroom
export const ON_RECEIVED_FROM_CHAT_ROOM_CHANNEL = 'ON_RECEIVED_FROM_CHAT_ROOM_CHANNEL'
export const SAVE_FETCHED_CHAT_ROOMS_TO_STORE = 'SAVE_FETCHED_CHAT_ROOMS_TO_STORE'
export const SAVE_FETCHED_CHAT_ROOMS_TO_STORE_REQUEST = 'SAVE_FETCHED_CHAT_ROOMS_TO_STORE_REQUEST'
export const SAVE_FETCHED_MESSAGES_TO_STORE = 'SAVE_FETCHED_MESSAGES_TO_STORE'
export const SAVE_FETCHED_MESSAGES_TO_STORE_REQUEST = 'SAVE_FETCHED_MESSAGES_TO_STORE_REQUEST'
export const UPDATE_TYPING_MESSAGE = 'UPDATE_TYPING_MESSAGE'
export const TOGGLE_SHOW_SUPPORT_CHAT_ROOM = 'TOGGLE_SHOW_SUPPORT_CHAT_ROOM'
export const LOAD_MORE_MESSAGES_REQUEST = 'LOAD_MORE_MESSAGES_REQUEST'
export const SAVE_LOADED_MESSAGES_TO_STORE= 'SAVE_LOADED_MESSAGES_TO_STORE'
export const SET_SHOWING_CHATROOM_ID = 'SET_SHOWING_CHATROOM_ID'

// My Page
export const TOGGLE_USER_INFO_MODAL = 'TOGGLE_USER_INFO_MODAL'
export const TOGGLE_SUB_MENU = 'TOGGLE_SUB_MENU'
export const TOGGLE_MOBILE_SUB_MENU = 'TOGGLE_MOBILE_SUB_MENU'

// Candidates
export const CANDIDATES_RESET_STATE = 'CANDIDATES_RESET_STATE'
export const UPDATE_CANDIDATES_DATA_SETTINGS = 'UPDATE_CANDIDATES_DATA_SETTINGS'
export const FETCH_CANDIDATES_DATA_REQUEST = 'FETCH_CANDIDATES_DATA_REQUEST'
export const UPDATE_STATUS_BAR_CONTENT = 'UPDATE_STATUS_BAR_CONTENT'
export const STATUS_BAR_RESET_STATE = 'STATUS_BAR_RESET_STATE'

// Candidate
export const UPDATE_CANDIDATE_DATA_SETTINGS = 'UPDATE_CANDIDATE_DATA_SETTINGS'
export const FETCH_CANDIDATE_DATA_REQUEST = 'FETCH_CANDIDATE_DATA_REQUEST'

// Opinion
export const RESET_PROPOSAL_STATE = 'RESET_PROPOSAL_STATE'
export const INIT_PROPOSAL = 'INIT_PROPOSAL'
export const UPDATE_ACCEPT_KEY = 'UPDATE_ACCEPT_KEY'
export const SET_ACCEPT_PRICE = 'SET_ACCEPT_PRICE'
export const ACCEPT_PROPOSAL_RESPONSE = 'ACCEPT_PROPOSAL_RESPONSE'
export const UPDATE_PAYMENT_KEY = 'UPDATE_PAYMENT_KEY'
export const GET_CARD_INFO_FROM_TOKEN = 'GET_CARD_INFO_FROM_TOKEN'
export const SET_SHOW_PROFILE_PRICE = 'SET_SHOW_PROFILE_PRICE'
export const PAY_SHOW_PROFILE_RESPONSE = 'PAY_SHOW_PROFILE_RESPONSE'
export const SET_DOCTOR_INFO = 'SET_DOCTOR_INFO'
export const UPDATE_SHOW_PROFILE_KEY = 'UPDATE_SHOW_PROFILE_KEY'

// Request edit
export const UPDATE_REQUEST_EDIT_SETTINGS = 'UPDATE_REQUEST_EDIT_SETTINGS'
export const CHANGE_REQUEST_EDIT_STEP = 'CHANGE_REQUEST_EDIT_STEP'

// User edit
export const USER_EDIT_SET_LOADING = 'USER_EDIT_SET_LOADING'

// Annotation image modal
export const TOGGLE_ANNOTATION_IMAGE_MODAL = 'TOGGLE_ANNOTATION_IMAGE_MODAL'

// Payments
export const UPDATE_PAYMENTS_DATA = 'UPDATE_PAYMENTS_DATA'
export const PAYMENT_SET_IS_LOADING = 'PAYMENT_SET_IS_LOADING'

// Email confirmation
export const UPDATE_EMAIL_CONFIRMATION_SETTINGS = 'UPDATE_EMAIL_CONFIRMATION_SETTINGS'

// Authentication code confirmation
export const UPDATE_AUTHENTICATION_CODE_DATA = 'UPDATE_AUTHENTICATION_CODE_DATA'

// Notification
export const ON_RECEIVE_FROM_NOTIFICATION_CHANNEL = 'ON_RECEIVE_FROM_NOTIFICATION_CHANNEL'
export const NOTIFICATION_NEW_CHATROOM = 'NOTIFICATION_NEW_CHATROOM'
export const INIT_NOTIFICATIONS = 'INIT_NOTIFICATIONS'
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION'
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION'

// Header User
export const TOGGLE_MOBILE_MENU = 'TOGGLE_MOBILE_MENU'

// Session Expired Modal
export const SHOW_SESSION_EXPIRED_MODAL = 'SHOW_SESSION_EXPIRED_MODAL'

// Request confirmation
export const REQUEST_CONFIRMATION_RESPONSE = 'REQUEST_CONFIRMATION_RESPONSE'



// WEBPACK FOOTER //
// ./src/modules/actions.js